




















import { Component, Vue, namespace, State } from 'nuxt-property-decorator'
import ExperienceSection from '~/components/setion/experience'

const ExperienceModule = namespace('experience')

@Component({
  components: {
    ExperienceSection,
    MobileRouteTransition: () => import('~/components/experience/route-transition/mobile/index.vue'),
    desktopRouteTransition: () => import('~/components/experience/route-transition/desktop/index.vue')
  }
})
export default class TourSectionList extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @ExperienceModule.State tourHomePageSections!: any

  get formatSections() {
    return (this.tourHomePageSections || []).map((item: any) => {
      const { name: id, type } = item.meta

      return {
        id,
        type,
        data: item
      }
    })
  }

  get transitionComponent() {
    return this.platform === 'desktop' ? 'desktopRouteTransition' : 'MobileRouteTransition'
  }
}
